import { render } from "./SettingPanelButtons.vue?vue&type=template&id=1540df2a&scoped=true&ts=true"
import script from "./SettingPanelButtons.vue?vue&type=script&lang=ts"
export * from "./SettingPanelButtons.vue?vue&type=script&lang=ts"

import "./SettingPanelButtons.vue?vue&type=style&index=0&id=1540df2a&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1540df2a"]])

export default __exports__